<template>
  <div class="events-feed">
    <Hero :title="title" :subtitle="subtitle" />
    <Search />
    <Filters />
    <slot name="events" v-if="showFeaturedEvents" />
    <Feed />
  </div>
</template>

<script>
import Filters from './components/Filters';
import Hero from './components/Hero';
import Search from './components/Search';
import Feed from './components/Feed';
import store from './store/store';

import { mapGetters } from 'vuex';

export default {
  name: 'EventsFeed',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  methods: {},
  store: store,
  computed: {
    ...mapGetters({
      searchTerm: 'rf/getSearchTerm',
      searchDate: 'rf/getSearchDate',
      showFeaturedEvents: 'rf/getShowFeaturedEvents',
      currentTaxonomies: 'rf/getCurrentTaxonomies'
    })
  },
  components: {
    Hero,
    Filters,
    Search,
    Feed
  }
};
</script>

<style></style>
